import { Avatar, List, PageHeader } from 'antd';
import React, { ReactNode } from 'react';

import imgAg from '../img/pageContact/andrean.jpg';
import imgAn from '../img/pageContact/andreas_eckert.png';
import imgBj from '../img/pageContact/bjgohlke.jpg';
import imgFe from '../img/pageContact/fei.jpeg';
import imgKa from '../img/pageContact/kathleen.jpg';
import imgLa from '../img/pageContact/lakshmi.png';
import imgLe from '../img/pageContact/lena.gif';
import imgMa from '../img/pageContact/mathias.jpg';
import imgPr from '../img/pageContact/rpreissner.jpg';
import imgQi from '../img/pageContact/qiaofeng.jpg';
import imgRe from '../img/pageContact/renata.jpg';
import imgSu from '../img/pageContact/su.jpg';
import imgUs from '../img/pageContact/user.jpg';

interface StringObjectKey {
    [index: string]: string;
}

const pics: StringObjectKey = {
    imgPr: imgPr,
    imgBj: imgBj,
    imgQi: imgQi,
    imgLe: imgLe,
    imgAg: imgAg,
    imgMa: imgMa,
    imgRe: imgRe,
    imgAn: imgAn,
    imgUs: imgUs,
    imgFe: imgFe,
    imgKa: imgKa,
    imgLa: imgLa,
    imgSu: imgSu,
};

const data: {
    title: string;
    email?: string;
    role?: string;
    pic: string;
}[] = [
    {
        title: 'Dr. Robert Preissner',
        email: 'robert.preissner@charite.de',
        pic: 'imgPr',
    },
    {
        title: 'Dr. Björn Oliver Gohlke',
        email: 'bjoern-oliver.gohlke@charite.de',
        role: 'Similarity related queries',
        pic: 'imgBj',
    },
    {
        title: 'Qiaofeng Chen',
        email: 'qiaofeng.chen@charite.de',
        role: 'Data related queries',
        pic: 'imgQi',
    },
    {
        title: 'Dr. Lena Springer',
        email: 'l.springer@mailbox.org',
        role: 'Traditional chinese medicine related queries',
        pic: 'imgLe',
    },
    {
        title: 'Dr. Andrean Goede',
        email: 'andrean.goede@charite.de',
        role: 'KEGG Pathways enrichment analysis',
        pic: 'imgAg',
    },
    {
        title: 'Dr. Mathias Dunkel',
        email: 'mathias.dunkel@charite.de',
        role: 'KEGG Pathways related queries',
        pic: 'imgMa',
    },
    {
        title: 'Kathleen Gallo',
        email: 'kathleen.gallo@charite.de',
        role: 'Diseases related queries',
        pic: 'imgKa',
    },
    {
        title: 'Renata Abel',
        email: 'renata.abel@charite.de',
        role: 'Targets related queries',
        pic: 'imgRe',
    },
    {
        title: 'Andreas Eckert',
        email: 'andreas.eckert@charite.de',
        role: 'Ingredients related queries',
        pic: 'imgAn',
    },
    {
        title: 'Lakshmi Seshadri',
        email: 'lakshmis97@zedat.fu-berlin.de',
        role: 'Website',
        pic: 'imgLa',
    },
    {
        title: 'Stefano Trambusti',
        role: 'Website',
        pic: 'imgUs',
    },
    {
        title: 'Su Gao',
        email: 'gfast2@gmail.com',
        role: 'Website',
        pic: 'imgSu',
    },
    {
        title: 'Fei Shan',
        role: 'Logo Design',
        pic: 'imgFe',
    },
];

const PageContact: React.FC = () => (
    <div>
        <PageHeader title="Contact" style={{ marginBottom: '10vh' }} />
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
                fontSize: 20,
                color: 'red',
                marginBottom: '7vh',
            }}
        >
            THE TEAM
        </div>
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'normal',
                fontSize: 16,
                color: 'black',
                marginBottom: '10vh',
            }}
        >
            <List
                grid={{ gutter: 30 }}
                dataSource={data}
                renderItem={(item): ReactNode => (
                    <List.Item style={{ width: '275px', padding: '15px' }}>
                        <List.Item.Meta
                            avatar={<Avatar src={pics[item.pic]} />}
                            title={item.title}
                            description={
                                <>
                                    <a href={'mailto:' + item.email}>{item.email}</a>
                                    <div>{item.role}</div>
                                </>
                            }
                        />
                    </List.Item>
                )}
            />
        </div>
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'normal',
                fontSize: 16,
                color: 'black',
            }}
        >
            <table style={{ borderWidth: '2px', borderColor: 'black', padding: '20' }}>
                <tr>
                    <td style={{ textAlign: 'center', fontWeight: 'bold', color: 'red', fontSize: 25 }}> Institute </td>
                </tr>
                <tr>
                    <td style={{ textAlign: 'center' }}>
                        <a href={'http://bioinf-apache.charite.de/main/index.php'}>Structural Bioinformatics Group</a>{' '}
                    </td>
                </tr>
                <tr>
                    <td style={{ textAlign: 'center' }}> Charite - University Medicine Berlin </td>
                </tr>
                <tr>
                    <td style={{ textAlign: 'center' }}> Philippstraße 12, 10115 Berlin </td>
                </tr>
                <tr>
                    <td style={{ textAlign: 'center' }}>
                        {' '}
                        <text style={{ fontWeight: 'bold' }}>Phone:</text> +49 30 4505 28257{' '}
                    </td>
                </tr>
                <tr>
                    <td style={{ textAlign: 'center' }}>
                        {' '}
                        <text style={{ fontWeight: 'bold' }}>Email:</text>{' '}
                        <a href={'robert.preissner@charite.de'}>robert.preissner@charite.de</a>{' '}
                    </td>
                </tr>
            </table>
        </div>
    </div>
);

export default PageContact;
